              
<!-- 学校考勤时间设置 -->

<template>
  <div class="fuzzy-matching-box">
        <div class="header-Top-Box">
            <!-- <h1 class="anquan-text">考勤时间设置</h1> -->
            <div class="school-seacher">
                <el-button type="primary" class="query-button" @click="AddTimeClick"  icon="el-icon-edit">新增</el-button>
                <el-button type="danger" class="delete-Btn" @click="entrylogClick">批量删除</el-button>
            </div>
        </div>
        <div class="center-table-box"> 
            <el-table
                 stripe
                :border="true"
                class="table-Style"
                ref="multipleTable"
                :header-cell-style="{background:'#EDF6FF',color:'#000',}"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%,"
                @selection-change="handleSelectionChange">
                <el-table-column
                type="selection"
                > 
                </el-table-column>
                <el-table-column
                type="index"
                label="序号"
                >
                </el-table-column>
                <el-table-column
                  prop="attendanceUserType"
                  label="考勤对象"
                >
                <template #default="scope">
                  <span v-if="scope.row.attendanceUserType == 1" >老师</span>
                  <span v-if="scope.row.attendanceUserType == 0" >学生</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="day"
                label="星期"
                >
                <template #default="scope">
                  <span v-if="scope.row.day == 1" >周一</span>
                  <span v-if="scope.row.day == 2" >周二</span>
                  <span v-if="scope.row.day == 3" >周三</span>
                  <span v-if="scope.row.day == 4" >周四</span>
                  <span v-if="scope.row.day == 5" >周五</span>
                  <span v-if="scope.row.day == 6" >周六</span>
                  <span v-if="scope.row.day == 7" >周日</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="amEnterTime"
                label="上午开始"
              >
                </el-table-column>
                <el-table-column
                prop="amLeaveTime"
                label="上午结束"
              >
                </el-table-column>
                <el-table-column
                prop="pmEnterTime"
                label="下午开始"
              >
                </el-table-column>
                <el-table-column
                prop="pmLeaveTime"
                label="下午结束"
              >
                </el-table-column>
                <el-table-column
                prop="nightEnterTime"
                label="晚上开始"
              >
                </el-table-column>
                <el-table-column
                prop="nightLeaveTime"
                label="晚上结束"
              >
                </el-table-column>
                <el-table-column
                prop="created"
                label="添加时间"
              >
                </el-table-column>
                <el-table-column
                label="操作"
              >
              <template #default="scope">
                 <el-button type="text" size="small" class="xiugai-btn" @click="xiugaiClick(scope.row)" >编辑</el-button>
                 <el-button type="text" size="small" class="delete-Btn"  @click="deleteClick(scope.row)">删除</el-button>
               </template>
                </el-table-column>
            </el-table>
        </div>
        <TimeAdd 
        v-if="TimeShowAdd" 
        @FatcherClick="FatcherClick" 
        :SchoolId="SchoolId"
        :xiugaiItem="xiugaiItem"
        ></TimeAdd>
  </div>
</template>

<script>
import {schoolTimeUserList,attendanceTimeDelete} from '@/assets/api/schoollog';
import {findTeacherInfo} from '@/assets/api/renyuan';
import TimeAdd from './TimeAdd/index.vue'
export default {
  components: {
    TimeAdd
  },
  mixins: [],
  data() {
    return {
      tableData:[],
      TimeShowAdd:false,
      SchoolId:'',
      xiugaiItem: {},
      deleteList: []
    }
  },
  computed: {
    
  },
  created(){
    this.findTeacherInfoSchoolId()
  },
  mounted() {
    
  },
  methods: {
    //查看权限
    findTeacherInfoSchoolId(){
          const params = {
           userId:JSON.parse(localStorage.getItem('user')).id,
              }
        findTeacherInfo(params).then((res)=> {
          console.log(res,'学校管理员');
           if(res.data.data.schoolId != null && res.data.data.gradeId === null && res.data.data.classId === null){
              this.SchoolId = res.data.data.schoolId
              this.schoolTimeUserListSecher()
           }else{
            console.log('没有权限');
           }
      }).catch((err)=> {
             console.log(err);
      })
    },
    //列表
    schoolTimeUserListSecher(){
      const params = {
        schoolId:this.SchoolId
      }
      schoolTimeUserList(params).then((res)=> {
        console.log(res,111111);
        this.tableData = res.data.data
      }).catch((err)=> {
        console.log(err);
      })
    },
    xiugaiClick (item) {
      this.TimeShowAdd = true
      this.xiugaiItem = item
      console.log('修改');
    },
    AddTimeClick(){
      this.TimeShowAdd = true
    },
    FatcherClick(){
      this.xiugaiItem = {}
      this.findTeacherInfoSchoolId()
      this.TimeShowAdd = false
    },
    handleSelectionChange (val) {
      this.deleteList = val
      console.log(this.deleteList,'多选7777');
    },
    entrylogClick () {
      let arr = []
      for (let item of this.deleteList) {
        console.log(item.id,777777);
        arr.push(item.id)
      }
      let params = {
        ids: arr
      }
      attendanceTimeDelete(params).then((res)=> {
        console.log(res,'删除');
        this.$message({
                    type: 'success',		
                    message: '批量删除成功！'
                });
        this.schoolTimeUserListSecher()
      }).catch((err)=> {
        // console.log(err);
        this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
      })
    },
    deleteClick (item) {
      console.log(item,7777);
      let params = {
        ids: [ item.id ]
      }
      attendanceTimeDelete(params).then((res)=> {
        this.$message({
                    type: 'success',		
                    message: '删除成功！'
                });
        this.schoolTimeUserListSecher()
      }).catch((err)=> {
        // console.log(err);
        this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
      })
    },
  }
};
</script>
<style lang='scss' scoped>
   .fuzzy-matching-box{
       height: 96%;
       .header-Top-Box{
           height: 10%;
           background-color: #fff;
           border-radius: 10px;
           display: flex;
           justify-content: space-between;
           align-items: center; /*垂直居中*/
          .anquan-text{
           line-height:-20% !important;
           font-size: 18px;
           font-weight: 700;
           margin-left: 20px;

          }
          .school-seacher{
           :deep() {
               .el-row{
                   height: 40px;
                   line-height: 40px !important;
                   text-align: center;
                   
               }
               .el-input--small .el-input__inner{
                   height: 30px;
                   
               }
               .el-input--small .el-input__wrapper{
                   border-radius: 15px;
               }
               .el-form-item--small .el-form-item__label {
                   line-height: 30px !important;
                   font-size: 16px;
                   color: black;
               }
               .el-input__inner {
                   width: 150px;
                   margin-right:50px !important;
                   border-radius: 15px;
               }
               .query-button{
                   margin-left: 20px;
                  //  background-color:#1BC896;
                   font-size: 16px;
                   height: 35px;
                   width: 60px;
                  //  border-radius:10px
               }
               .delete-Btn{
                   margin-right: 50px;
                   margin-left: 20px;
                   font-size: 16px;
                   height: 35px;
                   width: 80px;
                  //  border-radius:10px;
                   background-color:red;

               }

           }
           
          }

       }
       .center-table-box{
           height: 85%;
           margin-top: 20px;
           background-color: #fff;
           // background-color: green;
           border-radius: 10px;
           // overflow: auto;
           padding: 20px;
           .table-Style{
              //  border-radius: 15px;
           }
           :deep() {
         
              .xiugai-btn{
                   font-size: 15px;
                  //  color:#28C897;
                   font-weight: 700;
              }
              .delete-Btn{
                font-size: 15px;
                font-weight: 700;
                color: red !important;
              }
              .el-table th.el-table__cell>.cell{
                height: 30px;
                line-height: 30px;
                   font-size: 15px;
                   font-weight: 700;
               }
               .el-table__header{
                  //  height: 30px;
                  //  font-size: 16px;
                  //  font-weight: 700;
                  //  border-radius: 15px;

               }
               .el-table--small .cell {
                text-align: center;
               }
               .el-table--enable-row-transition .el-table__body td.el-table__cell {
                  //  border: none;
                   height: 40px;
                   font-size: 16px;
               }
               }
           .block-fenye{
               margin-top: 20px;
               margin-left: 80%;
           }
       }
   }
</style>